import { FunctionComponent, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ContainerDashboardComponent from "../../components/container.components";
import { RESOURCE_CHILDREN_TYPES, RESOURCE_TYPE_TO_NAMES, RESOURCE_TYPE_TO_STRING } from "../../constants/resource-names.constants";
import LoadingElement from "../../elements/loading.elements";
import ResourcesGetHttp from "../../http/resources/get.resources.http";
import { ResourceType, ResourceModel } from "../../models/resource.models";
import HeaderResourcesWidget from "./header.resources.widgets";
import { ReactComponent as ExpandSvg } from "../../constants/svg/expand.svg";

interface IShowResourcesWidgetProps {
  resourceType: ResourceType
  uuidResource: string
}

const ShowResourcesWidget: FunctionComponent<IShowResourcesWidgetProps> = ({
    resourceType,
    uuidResource
}) => {
  const { pathname } = useLocation()

  const header = <HeaderResourcesWidget  title={`${RESOURCE_TYPE_TO_NAMES[resourceType]} Resources`}>
    {RESOURCE_CHILDREN_TYPES[resourceType].map(childType => {
      return <Link key={childType} to={`${pathname}/${RESOURCE_TYPE_TO_STRING[childType]}/new`}>
        <p className="px-4 py-2 bg-sky-200 rounded-lg font-semibold uppercase">ADD {RESOURCE_TYPE_TO_NAMES[childType]}</p>
      </Link>
    })}
  </HeaderResourcesWidget>

  const [ loading, setLoading ] = useState(true)
  const [ hasMore, setHasMore ] = useState(false)
  const [ resource, setResource ] = useState<ResourceModel|undefined>()
  const [ resourceChildrenList, setResourceChildren ] = useState<Array<ResourceModel>>([])

  async function fetchResources() {
    setLoading(true)
    const response = await new ResourcesGetHttp().getSingle({
      uuid: uuidResource,
      getChildren: true
    })
    setResource(response.resource)
    setResourceChildren([...resourceChildrenList, ...response.children])
    setLoading(false)
  }

  useEffect(() => {
    fetchResources()
  }, [])

  const resourceView = resource && <div className="container max-w-screen-lg px-2 py-6">
    <div key={resource.uuid} className="border border-neutral-200 rounded-lg pb-4">
      <p className="px-4 py-3 font-semibold text-center border-b border-neutral-200">Parent resource - {RESOURCE_TYPE_TO_NAMES[resource.type]}</p>
      <p className="px-4 uppercase text-sm text-neutral-400 mt-4">Name</p>
      <p className="px-4"> {resource.name}</p>
      <p className="px-4 uppercase text-sm text-neutral-400 mt-4">Title</p>
      <p className="px-4"> {resource.title}</p>
      <p className="px-4 uppercase text-sm text-neutral-400 mt-4">Description</p>
      <p className="px-4"> {resource.description}</p>
    </div>
  </div>

  return <ContainerDashboardComponent header={header}>
    {resourceView}
    <div className="container max-w-screen-lg px-2 py-6 grid grid-cols-2 gap-4">
      {resourceChildrenList.map(resource => {
        let additionalViews
        if (resource.type === ResourceType.TEXT) {
          additionalViews = <>
            <p className="px-4 uppercase text-sm text-neutral-400 mt-4">Text - English</p>
            <p className="px-4"> {resource.lang.ENGLISH}</p>
          </>
        }
        if (resource.type === ResourceType.IMAGE) {
          additionalViews = <>
            <div className="mx-4 mt-4 rounded-lg overflow-hidden aspect-video">
              <img src={resource.url} className="w-full h-full object-cover" />
            </div>
          </>
        }
        if (resource.type === ResourceType.ALBUM) {
          additionalViews = <>
          </>
        }
        if (resource.type === ResourceType.GALLERY) {
          additionalViews = <>
          </>
        }
        return <div key={resource.uuid} className="border border-neutral-200 rounded-lg pb-4">
          <div className="flex flex-row justify-between items-center border-b border-neutral-200">
            <p className="px-4 font-semibold">{RESOURCE_TYPE_TO_NAMES[resource.type]}</p>
            <div className="px-4 py-1">
              <Link to={`/resources/${RESOURCE_TYPE_TO_STRING[resource.type]}/${resource.uuid}`}>
                <ExpandSvg className="border border-neutral-200 rounded-lg hover:bg-sky-200 w-10 h-10 p-2 fill-neutral-400 hover:fill-neutral-800" />
              </Link>
            </div>
          </div>
          <p className="px-4 uppercase text-sm text-neutral-400 mt-4">Name</p>
          <p className="px-4"> {resource.name}</p>
          <p className="px-4 uppercase text-sm text-neutral-400 mt-4">Title</p>
          <p className="px-4"> {resource.title}</p>
          <p className="px-4 uppercase text-sm text-neutral-400 mt-4">Description</p>
          <p className="px-4"> {resource.description}</p>
          
          {additionalViews}
        </div>
      })}
      {(!loading && hasMore) && <div className="border border-neutral-200 p-4 rounded-lg col-span-2">
        <p>Load More</p>
      </div>}
      {(!loading && resourceChildrenList.length === 0) && <div className="p-4 rounded-lg col-span-2">
        <p className="text-center">No Children Resources Found</p>
      </div>}
      {loading && <div className="border border-neutral-200 p-4 rounded-lg col-span-2">
        <LoadingElement />
      </div>}
    </div>
  </ContainerDashboardComponent>
}

export default ShowResourcesWidget